// Helper standard pattern shadcn: combina clsx + tailwind-merge per gestire
// conflitti di utility classes (es. p-4 + p-6 -> p-6 vince).

import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
